package com.exura.features.firebase.domain.repository

import com.exura.features.firebase.domain.model.SerializableDomainModel
import dev.gitlive.firebase.firestore.CollectionReference
import dev.gitlive.firebase.firestore.DocumentReference
import kotlinx.coroutines.flow.Flow

interface SerializableDomainModelRepositoryIO<in I: SerializableDomainModel, out O : SerializableDomainModel> {

    suspend fun create(item: I, dest: CollectionReference): Result<O>

    suspend fun read(source: DocumentReference) : Result<O>

    suspend fun update(item: I, dest: DocumentReference): Result<O>


    suspend fun set(item: I, dest: DocumentReference): Result<O>

    suspend fun delete(dest: DocumentReference) : Result<Boolean>

    suspend fun list(dest: CollectionReference): Flow<List<O>>

    suspend fun delete(id: String, dest: CollectionReference): Result<Boolean> = delete(dest.document(id))

    suspend fun create(item: I): Result<O> = create(item, item.firebaseDocPrefix!!)

    suspend fun update(item: I): Result<O> = update(item, item.getFirebaseDocRef())

    suspend fun read(id: String, source: CollectionReference): Result<O> = read(source.document(id))

    suspend fun save(item: I, dest: CollectionReference, id: String? = null): Result<O> = runCatching {
        if (id != null) {
            return set(item, dest.document(id))
        } else {
            return create(item, dest)
        }
    }

    suspend fun save(item: I): Result<O> = save(item, item.firebaseDocPrefix!!, item.firebaseDocId)

    suspend fun save(item: I, dest: DocumentReference): Result<O> = save(item, dest.parent, dest.id)

    suspend fun save(item: I, dest: CollectionReference): Result<O> = save(item, dest, item.firebaseDocId)

}

typealias SerializableDomainModelRepository<T> = SerializableDomainModelRepositoryIO<T, T>
